<div *ngIf="tags">
  <label>Cambia tag</label>
  <p-dropdown
    [placeholder]="tags.length === 0 ? 'Non ci sono tag.' : 'Scegli...'"
    [formControl]="tag"
    [options]="tags"
    dataKey="id"
    [showClear]="true"
    optionLabel="description"
    styleClass="w-full"
    [filter]="true"
    appendTo="body"
    [emptyMessage]="'Nessun risultato trovato'"></p-dropdown>
</div>
<div class="mt-4 flex justify-content-center">
  <p-button
    [label]="'Salva'"
    type="submit"
    styleClass="butt  mx-auto "
    [rounded]="true"
    (click)="save()"></p-button>
</div>
